export const components = [
  {
    label: "Accordion",
    id: "accordion",
    icon: "accordion",
    description:
      "Vertically stacked interactive headings that reveal sections of content.",
  },
  {
    label: "Angle Slider",
    id: "angle-slider",
    icon: "slider",
    description:
      "Circular slider for selecting angle values from 0 to 360 degrees.",
  },
  {
    label: "Avatar",
    id: "avatar",
    icon: "user",
    description:
      "Displays user profile pictures with fallback initials or placeholder.",
  },
  {
    label: "Cascade Select",
    id: "cascade-select",
    beta: true,
    icon: "select",
    description:
      "Hierarchical dropdown for selecting values across multiple levels.",
  },
  {
    label: "Carousel",
    id: "carousel",
    beta: true,
    icon: "carousel",
    description: "Navigate through multiple items in a slideshow format.",
  },
  {
    label: "Checkbox",
    id: "checkbox",
    icon: "checkbox",
    description: "Binary input control for selecting multiple options.",
  },
  {
    label: "Clipboard",
    id: "clipboard",
    icon: "clipboard",
    description: "Copy text or data to the user's clipboard.",
  },
  {
    label: "Collapsible",
    id: "collapsible",
    icon: "collapsible",
    description: "Show and hide content sections with smooth animations.",
  },
  {
    label: "ColorPicker",
    id: "color-picker",
    icon: "color",
    description: "Select colors using various input methods and formats.",
  },
  {
    label: "Combobox",
    id: "combobox",
    icon: "combobox",
    description: "Text input with searchable dropdown options.",
  },
  {
    label: "Date Picker",
    id: "date-picker",
    icon: "calendar",
    description: "Select dates using an interactive calendar interface.",
  },
  {
    label: "Dialog",
    id: "dialog",
    icon: "dialog",
    description:
      "Modal windows that capture focus and require user interaction.",
  },
  {
    label: "Editable",
    id: "editable",
    icon: "edit",
    description: "Inline text editing with preview and edit modes.",
  },
  {
    label: "File Upload",
    id: "file-upload",
    icon: "upload",
    description:
      "Drag and drop or click to upload files with progress tracking.",
  },
  {
    label: "Floating Panel",
    id: "floating-panel",
    icon: "panel",
    description: "Repositionable panel that floats above other content.",
  },
  {
    label: "Hover Card",
    id: "hover-card",
    icon: "card",
    description: "Preview content that appears when hovering over triggers.",
  },
  {
    label: "Image Cropper",
    id: "image-cropper",
    beta: true,
    icon: "crop",
    description: "Crop and resize images with interactive handles.",
  },
  {
    label: "Listbox",
    id: "listbox",
    icon: "list",
    description: "Select single or multiple items from a list of options.",
  },
  {
    label: "Menu",
    id: "menu",
    icon: "menu",
    description: "Navigate through grouped actions and commands.",
  },
  {
    label: "Context Menu",
    id: "context-menu",
    icon: "context",
    description: "Right-click menu with contextual actions.",
    package: "menu",
  },
  {
    label: "Nested Menu",
    id: "nested-menu",
    icon: "nested",
    description: "Multi-level menu with hierarchical navigation.",
    package: "menu",
  },
  {
    label: "Number Input",
    id: "number-input",
    icon: "number",
    description: "Input field for numeric values with increment controls.",
  },
  {
    label: "Pagination",
    id: "pagination",
    icon: "pagination",
    description: "Navigate through pages of content with page indicators.",
  },
  {
    label: "Password Input",
    id: "password-input",
    icon: "password",
    description: "Secure text input with visibility toggle functionality.",
  },
  {
    label: "Pin Input",
    id: "pin-input",
    icon: "pin",
    description: "Multiple character input fields for PIN or code entry.",
  },
  {
    label: "Popover",
    id: "popover",
    icon: "popover",
    description: "Floating content anchored to trigger elements.",
  },
  {
    label: "Presence",
    id: "presence",
    icon: "presence",
    description: "Animate elements entering and leaving the DOM.",
  },
  {
    label: "Progress - Linear",
    id: "linear-progress",
    icon: "progress",
    description: "Visual indicator of task completion progress.",
    package: "progress",
  },
  {
    label: "Progress - Circular",
    id: "circular-progress",
    icon: "circle",
    description: "Circular progress indicator for loading states.",
    package: "progress",
  },
  {
    label: "QR Code",
    id: "qr-code",
    icon: "qr",
    description: "Generate and display QR codes with customizable options.",
  },
  {
    label: "Radio Group",
    id: "radio-group",
    icon: "radio",
    description: "Single selection from a group of mutually exclusive options.",
  },
  {
    label: "Range Slider",
    id: "range-slider",
    icon: "range",
    description: "Select a range of values with dual handle sliders.",
    package: "slider",
  },
  {
    label: "Rating Group",
    id: "rating-group",
    icon: "star",
    description: "Star rating input for collecting user feedback.",
  },
  {
    label: "Scroll Area",
    id: "scroll-area",
    beta: true,
    icon: "scroll",
    description: "Custom scrollable areas with styled scrollbars.",
  },
  {
    label: "Segmented Control",
    id: "segmented-control",
    icon: "segment",
    description: "Switch between multiple exclusive options in segments.",
    package: "radio-group",
  },
  {
    label: "Select",
    id: "select",
    icon: "select",
    description: "Choose single or multiple options from a dropdown list.",
  },
  {
    label: "Signature Pad",
    id: "signature-pad",
    icon: "signature",
    description: "Capture digital signatures with touch or mouse input.",
  },
  {
    label: "Slider",
    id: "slider",
    icon: "slider",
    description: "Select numeric values from a continuous range.",
  },
  {
    label: "Splitter",
    id: "splitter",
    icon: "split",
    description: "Resizable panels with draggable dividers.",
  },
  {
    label: "Steps",
    id: "steps",
    icon: "steps",
    description: "Guide users through multi-step processes.",
  },
  {
    label: "Switch",
    id: "switch",
    icon: "switch",
    description: "Binary toggle control for on/off states.",
  },
  {
    label: "Tabs",
    id: "tabs",
    icon: "tabs",
    description: "Organize content into multiple panels with tab navigation.",
  },
  {
    label: "Tags Input",
    id: "tags-input",
    icon: "tags",
    description: "Input field for adding and managing multiple tags.",
  },
  {
    label: "Timer",
    id: "timer",
    icon: "timer",
    description: "Record elapsed time since zero or given time",
  },
  {
    label: "Toast",
    id: "toast",
    icon: "toast",
    description: "Brief notification messages that appear temporarily.",
  },
  {
    label: "Toggle Group",
    id: "toggle-group",
    icon: "toggle",
    description: "Group of toggleable buttons for multiple selections.",
  },
  {
    label: "Tooltip",
    id: "tooltip",
    icon: "tooltip",
    description: "Contextual information that appears on hover or focus.",
  },
  {
    label: "Tour",
    id: "tour",
    icon: "tour",
    description: "Guided walkthrough highlighting interface elements.",
  },
  {
    label: "Tree View",
    id: "tree-view",
    icon: "tree",
    description: "Hierarchical data display with expandable branches.",
  },
];
